import * as React from "react";
const SvgSpeed2X20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M3.761 8.795c-.015-.18-.045-.36-.045-.525 0-1.14.615-2.055 1.935-2.055 1.26 0 1.875.84 1.875 1.755 0 .795-.435 1.5-1.395 2.1l-1.755 1.125c-1.83 1.155-2.49 2.52-2.52 4.305h7.545v-1.62H4.076c.15-.585.615-.99 1.17-1.335l2.085-1.32c1.23-.765 2.01-1.89 2.01-3.285 0-1.785-1.35-3.3-3.645-3.3-2.37 0-3.735 1.635-3.735 3.465 0 .18.015.375.045.525l1.755.165Zm8.245-2.13L10.956 7.7l2.49 2.565-2.505 2.565 1.035 1.05 2.505-2.565 2.52 2.565 1.02-1.05-2.505-2.565 2.505-2.58-1.05-1.02-2.49 2.55-2.475-2.55Z"
    })
  );
export default SvgSpeed2X20Px;
